import moment from "moment";

function convertToCSV({ keys, headers, rows }) {
    const csvRows = [
        headers.join(","), // Header row
        ...rows.map(row =>
            keys.map(field => JSON.stringify(row[field] ?? "")).join(",")
        )
    ];
    return csvRows.join("\r\n");
}
function normalizeData(data, orderedFields, skipFields = [], headerConversion = {}) {
    const keys = orderedFields.filter(key => !skipFields.includes(key));

    const headers = keys.map((key:any) => headerConversion[key] ?? key);

    const rows = data.map(item => {
        const row = {};
        keys.forEach(key => {
            let value = item[key] ?? "";
            if (key === "createdAt" && value) {
                value = moment(value).format("MM-DD-YYYY / hh:mm:A");
            }
            row[key] = value;
        });
        return row;
    });

    return { keys, headers, rows };
  }
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
export async function generateJSONToCSV(data:any, orderedFields:any, skipFields:any, headerConversion = {}, filename = "data.csv") {
    const normalized = normalizeData(data, orderedFields, skipFields, headerConversion);
    const csv = convertToCSV(normalized);
    await delay(2000)
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
  